import styled from 'styled-components';

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width || '100%'};
  max-width: ${(props) => props.maxWidth || 'none'};
  min-width: 0;
  box-sizing: border-box;
  position: relative;
  overflow: visible;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.theme.name === 'dark' ? '#E5E7EB' : '#4B5563')};
`;

export const Required = styled.span`
  color: #ef4444;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px ${(props) => (props.hasCount ? '70px' : '40px')} 12px 14px;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#ffffff'};
  border: 1px solid
    ${(props) => {
      if (props.error) return '#ef4444';
      if (props.isOpen) return props.theme?.colors?.primary || '#fa4616';
      return props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.15)';
    }};
  border-radius: 6px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#1F2937')};
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;

  &:focus {
    border-color: ${(props) =>
      props.error ? '#ef4444' : props.theme?.colors?.primary || '#fa4616'};
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.error ? 'rgba(239, 68, 68, 0.1)' : 'rgba(250, 70, 22, 0.1)'};
  }

  &::placeholder {
    color: ${(props) => (props.theme.name === 'dark' ? '#6B7280' : '#9CA3AF')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CountBadge = styled.span`
  position: absolute;
  right: 36px;
  top: 50%;
  transform: translateY(-50%);
  background: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  color: white;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  pointer-events: none;
`;

export const DropdownIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%)
    ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  pointer-events: none;
  transition: transform 0.2s;
  color: ${(props) => (props.theme.name === 'dark' ? '#9CA3AF' : '#6B7280')};
  display: flex;
  align-items: center;
`;

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: ${(props) =>
    props.theme.name === 'dark' ? '#1F2937' : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.15)'};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 240px;
  overflow-y: auto;
  z-index: 1000;
`;

export const DropdownItem = styled.div`
  padding: 10px 14px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#1F2937')};
  background: ${(props) =>
    props.isHighlighted
      ? props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.03)'
      : 'transparent'};
  transition: background 0.15s;

  &:hover {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.08)'
        : 'rgba(0, 0, 0, 0.05)'};
  }
`;

export const Checkbox = styled.div`
  width: 18px;
  height: 18px;
  border: 2px solid
    ${(props) =>
      props.checked
        ? props.theme?.colors?.primary || '#fa4616'
        : props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.3)'
        : 'rgba(0, 0, 0, 0.2)'};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.checked ? props.theme?.colors?.primary || '#fa4616' : 'transparent'};
  transition: all 0.15s;
  flex-shrink: 0;
`;

export const NoResults = styled.div`
  padding: 12px 14px;
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#9CA3AF' : '#6B7280')};
  text-align: center;
`;

export const LoadingText = styled.div`
  padding: 12px 14px;
  font-size: 14px;
  color: ${(props) => (props.theme.name === 'dark' ? '#9CA3AF' : '#6B7280')};
  text-align: center;
`;

export const SelectedSection = styled.div`
  margin-top: 12px;
  padding: 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(0, 0, 0, 0.02)'};
  border: 1px dashed
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'};
  border-radius: 6px;
`;

export const SelectedHeader = styled.div`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${(props) => (props.theme.name === 'dark' ? '#64748b' : '#94a3b8')};
  margin-bottom: 10px;
  font-weight: 500;
`;

export const SelectedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SelectedItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.05)'
      : 'rgba(0, 0, 0, 0.03)'};
  border-radius: 4px;
  font-size: 13px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#1F2937')};
`;

export const SelectedItemLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: ${(props) => (props.theme.name === 'dark' ? '#64748b' : '#9CA3AF')};
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  transition: all 0.15s;
  flex-shrink: 0;

  &:hover {
    color: #ef4444;
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(239, 68, 68, 0.15)'
        : 'rgba(239, 68, 68, 0.1)'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    &:hover {
      color: ${(props) =>
        props.theme.name === 'dark' ? '#64748b' : '#9CA3AF'};
      background: transparent;
    }
  }
`;

export const EmptySelected = styled.div`
  font-size: 13px;
  color: ${(props) => (props.theme.name === 'dark' ? '#64748b' : '#9CA3AF')};
  text-align: center;
  padding: 8px;
`;

export const HelperText = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: ${(props) => (props.error ? '#ef4444' : '#64748B')};
`;

export const SelectAllRow = styled.div`
  padding: 8px 14px;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.08)'};
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  transition: background 0.15s;

  &:hover {
    background: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.03)'};
  }
`;
